import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Stack,
} from "@mui/material";

type Props = {
  count?: number;
};

function WallPostSkeletonItem() {
  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader
        avatar={<Skeleton variant="circular" width={40} height={40} />}
        title={
          <Stack direction="row" spacing={1} alignItems="center">
            <Skeleton variant="text" width={120} height={24} />
            <Skeleton variant="rounded" width={72} height={24} />
          </Stack>
        }
        subheader={<Skeleton variant="text" width={80} height={18} />}
        action={<Skeleton variant="circular" width={32} height={32} />}
      />
      <CardContent sx={{ pt: 0 }}>
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="92%" />
        <Skeleton variant="text" width="75%" />
        <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
          <Skeleton variant="rounded" width={56} height={28} />
          <Skeleton variant="rounded" width={56} height={28} />
          <Skeleton variant="rounded" width={56} height={28} />
        </Stack>
        <Box sx={{ mt: 2, pt: 1.5, borderTop: 1, borderColor: "divider" }}>
          <Skeleton variant="rounded" width="100%" height={36} />
        </Box>
      </CardContent>
    </Card>
  );
}

export default function WallPostSkeleton({ count = 3 }: Props) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <WallPostSkeletonItem key={i} />
      ))}
    </>
  );
}
